<template>
  <one-page-layout>
    <div class="wating__picture">
      <img src="../assets/images/waiting.png" alt="即將揭曉你的市場人格" />
    </div>
    <p class="wating__text">即將揭曉你的市場人格...</p>
    <div class="wating__progress">
      <div
        :style="{ width: `${ progress }%` }"
        class="wating__progress--active"
      ></div>
    </div>
  </one-page-layout>
</template>

<script>
import OnePageLayout from './OnePageLayout';

export default {
  name: 'ProgressPage',
  props: {
    totalSeconds: {
      type: Number,
      default: () => 3,
    },
  },
  data() {
    return {
      currentSeconds: 0,
      startTime: null,
      progress: 0,
    };
  },
  mounted() {
    this.startProgress();
  },
  components: {
    OnePageLayout,
  },
  methods: {
    startProgress() {
      this.startTime = null;
      this.currentSeconds = 0;
      requestAnimationFrame(this.updateProgress);
    },
    updateProgress(currentTime) {
      if (!this.startTime) {
        this.startTime = currentTime;
      }
      const elapsedTime = currentTime - this.startTime;
      this.progress = (elapsedTime / (1000 * this.totalSeconds)) * 100; // 進度條的總時間為2秒
      if (this.progress < 100) {
        requestAnimationFrame(this.updateProgress);
      }
    },
  },
};
</script>

<style scoped>
.wating {
}
.wating__picture {
  width: 132px;
}
.wating__text {
  font-size: 16px;
  color: #4f4f4f;
  width: 100%;
  text-align: center;
  padding: 20px 0 24px;
}
.wating__progress {
  width: 180px;
  height: 6px;
  background-color: #e4e4e4;
  border-radius: 100px;
}
.wating__progress--active {
  width: 0;
  height: 6px;
  background-color: #FFB13B;
  border-radius: 100px;
}
</style>
